var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"value":_vm.inputText,"label":_vm.label,"readonly":""}}),_c('copy-button',{staticClass:"mb-0",attrs:{"block":"","textToCopy":_vm.inputText,"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }